import { useState, useEffect } from "react";
import axios from "axios";
import "./AdminDashboard.css";
import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("team");

  // State for forms
  const [teamForm, setTeamForm] = useState({ name: "", role: "", linkedin_url: "", image: null });
  const [careersForm, setCareersForm] = useState({ position: "", experience: "", location: "", job_type: "Full Time" });
  const [eventsForm, setEventsForm] = useState({ title: "", image: null });

  // State to hold existing records
  const [teams, setTeams] = useState([]);
  const [careers, setCareers] = useState([]);
  const [events, setEvents] = useState([]);

  const API_URL = "http://localhost:5000"; // change if your backend is deployed elsewhere

  // Fetch current data from database
  const fetchData = async () => {
    try {
      const teamRes = await axios.get(`${API_URL}/api/team`);
      setTeams(teamRes.data);

      const careerRes = await axios.get(`${API_URL}/api/careers`);
      setCareers(careerRes.data);

      const eventsRes = await axios.get(`${API_URL}/api/events`);
      setEvents(eventsRes.data);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Handle form changes
  const handleTeamChange = (e) => {
    const { name, value, files } = e.target;
    setTeamForm((prev) => ({ ...prev, [name]: files ? files[0] : value }));
  };

  const handleCareersChange = (e) => {
    const { name, value } = e.target;
    setCareersForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEventsChange = (e) => {
    const { name, files } = e.target;
    setEventsForm((prev) => ({ ...prev, [name]: files[0] }));
  };

  // Submit handlers
  const submitTeam = async () => {
    try {
      const formData = new FormData();
      formData.append("name", teamForm.name);
      formData.append("role", teamForm.role);
      formData.append("linkedin_url", teamForm.linkedin_url);
      formData.append("image", teamForm.image);

      await axios.post(`${API_URL}/api/team`, formData, { headers: { "Content-Type": "multipart/form-data" } });
      alert("Team member added!");
      setTeamForm({ name: "", role: "", linkedin_url: "", image: null });
      fetchData(); // refresh list
    } catch (err) {
      console.error(err);
      alert("Error adding team member.");
    }
  };

const submitCareers = async () => {
  try {
    await axios.post(`${API_URL}/api/careers`, careersForm);
    alert("Career added!");

    // ✅ RESET STATE (NO HOOK)
    setCareersForm({
      position: "",
      experience: "",
      location: "",
      job_type: "Full-time",
    });

    fetchData();
  } catch (err) {
    console.error(err);
    alert("Error adding career.");
  }
};

  const submitEvents = async () => {
    try {
      const formData = new FormData();
      formData.append("title", eventsForm.title);
      formData.append("image", eventsForm.image);

      await axios.post(`${API_URL}/api/events`, formData, { headers: { "Content-Type": "multipart/form-data" } });
      alert("Event added!");
      setEventsForm({ title: "", image: null });
      fetchData();
    } catch (err) {
      console.error(err);
      alert("Error adding event.");
    }
  };

  // Delete handlers
  const deleteTeam = async (id) => {
    if (!window.confirm("Are you sure you want to delete this team member?")) return;
    try {
      await axios.delete(`${API_URL}/api/team/${id}`);
      fetchData();
    } catch (err) {
      console.error(err);
      alert("Error deleting team member.");
    }
  };

  const deleteCareer = async (id) => {
    if (!window.confirm("Are you sure you want to delete this career?")) return;
    try {
      await axios.delete(`${API_URL}/api/careers/${id}`);
      fetchData();
    } catch (err) {
      console.error(err);
      alert("Error deleting career.");
    }
  };

  const deleteEvent = async (id) => {
    if (!window.confirm("Are you sure you want to delete this event?")) return;
    try {
      await axios.delete(`${API_URL}/api/events/${id}`);
      fetchData();
    } catch (err) {
      console.error(err);
      alert("Error deleting event.");
    }
  };

return (
  <>
  <div className="admin-dashboard-mobile">
    <h2>Sorry Boss</h2>
  Admin Dashboard is accessible only on desktop devices.
</div>
  <div className="admin-dashboard-bg">
    <div className="admin-dashboard">
      {/* TOP BAR */}
      <div className="admin-topbar">
        <h3>Welcome, Admin 👋</h3>
        <button className="logout-btn" onClick={() => { localStorage.removeItem("cm_admin"); navigate("/"); }}>
          Logout
        </button>
      </div>

      {/* DASHBOARD CARDS */}
      <div className="admin-cards">
        <div className={`admin-card ${activeSection === "team" ? "active" : ""}`} onClick={() => setActiveSection("team")}>👥 Team Management</div>
        <div className={`admin-card ${activeSection === "careers" ? "active" : ""}`} onClick={() => setActiveSection("careers")}>💼 Careers Management</div>
        <div className={`admin-card ${activeSection === "events" ? "active" : ""}`} onClick={() => setActiveSection("events")}>📰 Events Management</div>
      </div>

      {/* TEAM FORM */}
      {activeSection === "team" && (
        <div className="admin-form-section">
          <h2>ADD TEAM MEMBER</h2>
          <input type="text" name="name" placeholder="Name" value={teamForm.name} onChange={handleTeamChange} />
          <input type="text" name="role" placeholder="Role" value={teamForm.role} onChange={handleTeamChange} />
          <input type="text" name="linkedin_url" placeholder="LinkedIn URL" value={teamForm.linkedin_url} onChange={handleTeamChange} />
          <input type="file" name="image" onChange={handleTeamChange} />
          <button className="modal-submit" onClick={submitTeam}>Add Member</button>
        </div>
      )}

      {/* TEAM CARDS */}
      {activeSection === "team" && (
        <div className="records-section">
          <h3>EXISTING TEAM MEMBERS</h3>
          <div className="records-grid">
            {teams.map((t) => (
              <div key={t.id} className="record-card">
                <img src={`${API_URL}/uploads/team/${t.image}`} alt={t.name} />
                <h4>{t.name}</h4>
                <p>{t.role}</p>
                <a href={t.linkedin_url} target="_blank" rel="noreferrer">LinkedIn</a>
                <button className="delete-btn" onClick={() => deleteTeam(t.id)}>Delete</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* CAREERS FORM */}
      {activeSection === "careers" && (
        <div className="admin-form-section">
          <h2>ADD POSITION</h2>
          <input type="text" name="position" placeholder="Position" value={careersForm.position} onChange={handleCareersChange} />
          <input type="text" name="experience" placeholder="Experience" value={careersForm.experience} onChange={handleCareersChange} />
          <input type="text" name="location" placeholder="Location" value={careersForm.location} onChange={handleCareersChange} />
          <select
  name="job_type"
  value={careersForm.job_type}
  onChange={handleCareersChange}
>
  <option value="Full-time">Full-time</option>
  <option value="Part-time">Part-time</option>
</select>
          <button className="modal-submit" onClick={submitCareers}>Add Position</button>
        </div>
      )}

      {/* CAREERS CARDS */}
      {activeSection === "careers" && (
        <div className="records-section">
          <h3>EXISTING CAREERS</h3>
          <div className="records-grid">
            {careers.map((c) => (
              <div key={c.id} className="record-card">
                <h4>{c.position}</h4>
                <p>{c.experience} years</p>
                <p>{c.location}</p>
                <p>{c.job_type}</p>
                <button className="delete-btn" onClick={() => deleteCareer(c.id)}>Delete</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* EVENTS FORM */}
      {activeSection === "events" && (
        <div className="admin-form-section">
          <h2>ADD EVENT</h2>
          <input type="text" name="title" placeholder="Event Title" value={eventsForm.title} onChange={(e) => setEventsForm({ ...eventsForm, title: e.target.value })} />
          <input type="file" name="image" onChange={handleEventsChange} />
          <button className="modal-submit" onClick={submitEvents}>Add Event</button>
        </div>
      )}

      {/* EVENTS CARDS */}
      {activeSection === "events" && (
        <div className="records-section">
          <h3>EXIXTING EVENTS</h3>
          <div className="records-grid">
            {events.map((ev) => (
              <div key={ev.id} className="record-card">
                <img src={`${API_URL}/uploads/events/${ev.image}`} alt={ev.title} />
                <button className="delete-btn" onClick={() => deleteEvent(ev.id)}>Delete</button>
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  </div>
    </>
);

};

export default AdminDashboard;
